import { useSelector } from 'react-redux'
import { ToolbarItem } from '../../../common/components/ToolbarItem'
import { Bookmark, House, Settings, User } from 'lucide-react'
import { FC, useState } from 'react'
import { useOpenLastApp, usePersonalAppsList } from '@wellesley/apps'
import { userSlice } from '@wellesley/user'
import { Application } from '@wellesley/openapi'
import { getRoute } from '@wellesley/router'
import { BOOKMARKS_ROUTE } from 'helpers/routes'
import { PersonalSpacePreview } from './PersonalSpacePreview'
import { LinkItem } from '../AppsList/LinkItem'
import { AppItem } from '../AppsList/AppItem'
import { SideBarTitle } from '../../../common/components/side-bar/SideBarTitle'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { useActiveItem, PERSONAL_SPACE_ID } from './hooks/useActiveItem'

export const PersonalSpace: FC = () => {
  const { changeActiveItemToPersonalSpace } = useActiveItem()
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)

  const getApps = usePersonalAppsList()
  const { openLastApp } = useOpenLastApp({ entryPoint: 'USER' })

  const linkList = [
    {
      Icon: User,
      link: getRoute('/@/:username', {
        username: currentUser && getUserNameWithDomain(currentUser),
      }),
      title: 'Profile',
    },
    {
      Icon: Bookmark,
      link: getRoute(BOOKMARKS_ROUTE),
      title: 'Bookmarks',
    },
    {
      Icon: Settings,
      link: getRoute('/settings/:tab?', { tab: 'profile' }),
      title: 'Settings',
    },
  ]

  const [list, setList] = useState<Application[]>([])
  const setApps = async () => {
    const list = await getApps()
    setList(list)
    return list
  }

  const handleClick = async () => {
    const list = await setApps()

    currentUser?.username &&
      void openLastApp({ username: currentUser?.username, defaultApp: list[0] })
  }

  return (
    <ToolbarItem
      id={PERSONAL_SPACE_ID}
      name="Home"
      Icon={House}
      onClick={() => void handleClick()}
      onHover={(isHovered) => {
        isHovered && void setApps()
      }}
      variant="square"
    >
      <div className="flex flex-col">
        <PersonalSpacePreview />
        <div className="flex flex-col gap-xxxs px-xs">
          <SideBarTitle title={`${currentUser ? 'Your' : ''} apps`} />
          {list?.map((app) => (
            <AppItem
              key={app.id}
              app={app}
              entryPoint="USER"
              size="lg"
              username={currentUser?.username}
              onClick={changeActiveItemToPersonalSpace}
            />
          ))}

          {currentUser && (
            <>
              <SideBarTitle title="General" />
              {linkList.map((link) => (
                <LinkItem
                  key={link.link}
                  {...link}
                  size="lg"
                  onClick={changeActiveItemToPersonalSpace}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </ToolbarItem>
  )
}
